import React from 'react';
import { ReturnRequestProvider } from '../Providers/ReturnRequestProvider';
import ReturnRequestIdentifyForm from '../Forms/ReturnRequestIdentifyForm.jsx';
import ReturnRequestForm from '../Forms/ReturnRequestForm.jsx';

export default class ReturnRequest extends React.Component {
	state = {
		phase: this.props.token ? 'loading' : 'identify',
		orderData: null,
		requestNumber: null,
		error: null
	}

	componentDidMount() {
		if (this.props.token) {
			ReturnRequestProvider.getAccess(
				this.props.token,
				(data) => {
					if (data.withdrawalPeriodState === 1 || data.withdrawalPeriodState === 0) { // Active or NotStarted
						this.setState({ phase: 'form', orderData: data });
					} else { // Expired
						this.setState({ phase: 'deadlinePassed' });
					}
				},
				() => this.setState({ phase: 'expired' })
			);
		}
	}

	handleIdentify = (payload) => {
		ReturnRequestProvider.identify(
			payload,
			() => this.setState({ phase: 'sent' }),
			() => this.setState({ phase: 'sent' }) // anti-enumeration: always show sent
		);
	}

	handleSubmit = (payload, done) => {
		ReturnRequestProvider.submit(
			payload,
			(data) => this.setState({ phase: 'success', requestNumber: data.requestNumber }),
			(err) => {
				this.setState({ error: err.msg });
				if (done) done();
			}
		);
	}

	render() {
		const T = window.Texts.returnRequest;
		const { phase, orderData, requestNumber, error } = this.state;

		if (phase === 'loading') {
			return <div className="cover"><div className="inner-500" style={{ padding: '40px 0' }}>...</div></div>;
		}

		if (phase === 'identify') {
			return <ReturnRequestIdentifyForm onSubmit={this.handleIdentify} />;
		}

		if (phase === 'sent') {
			return (
				<div className="cover">
					<div className="headline"><h1>{T.sentTitle}</h1></div>
					<div className="inner-500"><p>{T.sentText}</p></div>
				</div>
			);
		}

		if (phase === 'expired') {
			return (
				<div className="cover">
					<div className="headline"><h1>{T.expiredTitle}</h1></div>
					<div className="inner-500"><p>{T.expiredText}</p></div>
				</div>
			);
		}

		if (phase === 'notStarted') {
			return (
				<div className="cover">
					<div className="headline"><h1>{T.notStartedTitle}</h1></div>
					<div className="inner-500"><p>{T.notStartedText}</p></div>
				</div>
			);
		}

		if (phase === 'deadlinePassed') {
			return (
				<div className="cover">
					<div className="headline"><h1>{T.deadlinePassedTitle}</h1></div>
					<div className="inner-500">
						<p>{T.deadlinePassedText}</p>
						<p>{T.deadlinePassedContactInfo}</p>
					</div>
				</div>
			);
		}

		if (phase === 'form') {
			return (
				<>
					{error && <div className="cover"><p className="missing-entry"><strong>{error}</strong></p></div>}
					<ReturnRequestForm
						token={this.props.token}
						orderData={orderData}
						onSubmit={this.handleSubmit}
					/>
				</>
			);
		}

		if (phase === 'success') {
			return (
				<div className="cover">
					<div className="headline"><h1>{T.successTitle}</h1></div>
					<div className="inner-500">
						<p>{T.successText}</p>
						{requestNumber && (
							<p>
								<strong>{T.requestNumberLabel}:</strong>{' '}
								<span style={{ color: '#ED1C24', fontWeight: 'bold' }}>{requestNumber}</span>
							</p>
						)}
					</div>
				</div>
			);
		}

		return null;
	}
}
